import { useState } from "react";

import { Row, Col, Form, Input, Button, Alert } from "antd";

import Header from "../header";
import { login } from "../../../../api/auth";
import { putToLocalStorage } from "../../../../helpers/localstorage";

export default function Login() {
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleLogin = async (values) => {
    setError("");
    setIsSubmitting(true);

    try {
      const response = await login(values);

      if (response?.data?.token) {
        putToLocalStorage({ key: "token", value: response.data.token });
        putToLocalStorage({ key: "isSuperAdmin", value: response.data.isSuperAdmin });
        window.location.href = "/";
      }
    } catch (error) {
      if (error.response?.data?.message?.length) {
        setError("Invalid credentials");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Row
      className="hp-authentication-page hp-d-flex hp-bg-color-dark-90"
      style={{ flexDirection: "column" }}
    >
      <Col span={24}>
        <Header />
      </Col>

      <Col flex="1 0 0" className="hp-px-32 hp-mb-32">
        <Row
          className="hp-h-100 hp-m-auto"
          align="middle"
          style={{ maxWidth: 360 }}
        >
          <Col span={24}>
            <h1>Login</h1>

            <Form
              layout="vertical"
              name="basic"
              initialValues={{ remember: true }}
              className="hp-mt-sm-16 hp-mt-32"
              onFinish={handleLogin}
              validateTrigger="onSubmit"
              requiredMark={false}
            >
              <Form.Item
                label="Email:"
                name="email"
                className="hp-mb-16"
                rules={[
                  {
                    required: true,
                    message: "Please enter your email",
                  },
                  {
                    type: "email",
                    message: "Please enter a valid email",
                  },
                ]}
              >
                <Input id="error" />
              </Form.Item>
              <Form.Item
                label="Password:"
                name="password"
                className="hp-mb-8"
                rules={[
                  {
                    required: true,
                    message: "Please enter your password",
                  },
                ]}
              >
                <Input.Password id="warning2" />
              </Form.Item>

              <Col className="hp-mt-24 hp-mb-0">
                {!!error.length && (
                  <Alert
                    message={error}
                    type="error"
                    showIcon
                    className="hp-mb-0"
                  />
                )}

                <Form.Item>
                  <Button
                    className="hp-mt-24"
                    block
                    type="primary"
                    htmlType="submit"
                    disabled={isSubmitting}
                  >
                    Sign in
                  </Button>
                </Form.Item>
              </Col>
            </Form>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}
